module.exports = __webpack_public_path__ + "img/finish_company.5019d668.png";